import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        minWidth: "60%",
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
        borderRadius: 16
      }
    },
    dialogTitle: {
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      padding: "1.6rem 2.4rem",
      "& .MuiTypography-root": {
        color: theme.palette.info.main,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    },
    flexCenter: {
      display: "flex",
      alignItems: "center"
    },
    closeIcon: {
      cursor: "pointer",
      "& path": {
        stroke: theme.palette.grey[900]
      }
    },
    table: {
      overflow: "auto",
      marginTop: "0.8rem",
      width: "100%",
      border: "1px solid #E0E0E0",
      borderRadius: 4,
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "1.7rem 1.2rem",
          borderTop: `1px solid ${theme.palette.grey[300]}`,
          borderRight: `1px solid ${theme.palette.grey[300]}`
        },
        "& .MuiTableCell-root:last-child": {
          borderRight: "none"
        }
      },
      "& .MuiTableHead-root": {
        "& .MuiTableCell-root": {
          height: 78,
          padding: "1.7rem 1.2rem",
          borderRight: `1px solid ${theme.palette.grey[300]}`
        },
        "& .MuiTableCell-root:last-child": {
          borderRight: "none"
        }
      }
    },
    totalCell: {
      height: "36px !important"
    },
    flexCell: {
      display: "flex"
    },
    noBorderRight: {
      borderRight: "none !important"
    },
    col1: {
      minWidth: 120,
      maxWidth: 120
    },
    col2: {
      minWidth: 120,
      maxWidth: 120
    },
    col3: {
      minWidth: 250
    },
    col4: {
      minWidth: 350
    },
    col5: {
      minWidth: 112,
      borderRight: "none !important"
    },
    col7: {
      minWidth: 180,
      maxWidth: 180
    },
    col6: {
      minWidth: 72
    },
    boxContent: {
      padding: "0 1.4rem 2.4rem 2.4rem !important",
      overflowY: "scroll"
    },
    flex: { display: "flex", alignItems: "center" },
    marginRightHeader: {
      marginRight: "10px"
    }
  }),
  {
    name: "ModalDp"
  }
);

export default useStyles;
